/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface StudentProgressRow
 */
export interface StudentProgressRow {
    /**
     * 
     * @type {string}
     * @memberof StudentProgressRow
     */
    status: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof StudentProgressRow
     */
    count: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof StudentProgressRow
     */
    percentage: number;
}

/**
 * Check if a given object implements the StudentProgressRow interface.
 */
export function instanceOfStudentProgressRow(value: object): value is StudentProgressRow {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('percentage' in value) || value['percentage'] === undefined) return false;
    return true;
}

export function StudentProgressRowFromJSON(json: any): StudentProgressRow {
    return StudentProgressRowFromJSONTyped(json, false);
}

export function StudentProgressRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudentProgressRow {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'count': ApiUserTasksGetPageParameterFromJSON(json['count']),
        'percentage': json['percentage'],
    };
}

export function StudentProgressRowToJSON(json: any): StudentProgressRow {
    return StudentProgressRowToJSONTyped(json, false);
}

export function StudentProgressRowToJSONTyped(value?: StudentProgressRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'count': ApiUserTasksGetPageParameterToJSON(value['count']),
        'percentage': value['percentage'],
    };
}

